import { FAILURE, REQUEST, SUCCESS, updateObject, createReducer } from 'Stores'
import { GET_BREAD, GET_DRIVES_HOT_LOAD,
  GET_FILES_T0_DOWNLOAD_FOLDER, GET_ONE_DRIVE, GET_ONE_DRIVE_FOLDER_MOVE,
  GET_PORTFOLIO_DATA, GET_WEEKLY_NOTE, REMOVE_FILES_T0_DOWNLOAD_FOLDER, OPEN_FILE } from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  listOneDrive: [],
  listFolderMove: [],
  searchDrive: '',
  topLoad: 10,
  notes: [],
  portfolioData: null,
  listBread: [],
  listFilesToDownload: [],
  idParentMove: null,
  timezone: ''
}

function getOneDrive(state, { payload }) {
  const { search } = payload
  return updateObject(state, {
    isLoading: true,
    searchDrive: search
  })
}

function getOneDriveSuccess(state, { payload }) {
  const { listOneDrive, topLoad } = payload
  return updateObject(state, {
    isLoading: false,
    listOneDrive,
    topLoad
  })
}

function getFilesToDownloadFolderSuccess(state, { payload }) {
  const { listFilesToDownload } = payload
  return updateObject(state, {
    isLoading: false,
    listFilesToDownload
  })
}

function removeFilesToDownloadFolderSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    listFilesToDownload: []
  })
}

function getFolderMoveOneDriveSuccess(state, { payload }) {
  const { listFolderMove, idParentMove } = payload
  return updateObject(state, {
    isLoading: false,
    listFolderMove,
    idParentMove
  })
}

function getOneDriveFail(state, error) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getNote(state, error) {
  return updateObject(state, {
    isLoading: true,
    error
  })
}

function getNoteSuccess(state, { payload }) {
  const { notes, timezone } = payload
  return updateObject(state, {
    isLoading: false,
    notes,
    timezone
  })
}

function getOneFail(state, error) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getDriveHotLoadSuccess(state, { payload }) {
  const { topLoad, listOneDrive } = payload
  return updateObject(state, {
    isLoading: false,
    listOneDrive,
    topLoad
  })
}

function getBreadSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    listBread: payload
  })
}

function getPortfolioSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    portfolioData: payload
  })
}

function getOpenFileSuccess(state, { payload }) {
  return updateObject(state, {
    openFiles: payload
  })
}

export default createReducer(initialState, {
  [REQUEST(GET_ONE_DRIVE)]: getOneDrive,
  [SUCCESS(GET_ONE_DRIVE)]: getOneDriveSuccess,
  [SUCCESS(GET_ONE_DRIVE_FOLDER_MOVE)]: getFolderMoveOneDriveSuccess,
  [FAILURE(GET_ONE_DRIVE)]: getOneDriveFail,
  [REQUEST(GET_WEEKLY_NOTE)]: getNote,
  [SUCCESS(GET_WEEKLY_NOTE)]: getNoteSuccess,
  [FAILURE(GET_WEEKLY_NOTE)]: getOneFail,
  [SUCCESS(GET_DRIVES_HOT_LOAD)]: getDriveHotLoadSuccess,
  [SUCCESS(GET_BREAD)]: getBreadSuccess,
  [SUCCESS(GET_PORTFOLIO_DATA)]: getPortfolioSuccess,
  [SUCCESS(GET_FILES_T0_DOWNLOAD_FOLDER)]: getFilesToDownloadFolderSuccess,
  [SUCCESS(REMOVE_FILES_T0_DOWNLOAD_FOLDER)]: removeFilesToDownloadFolderSuccess,
  [SUCCESS(OPEN_FILE)]: getOpenFileSuccess
})
